require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./learn-and-live-in-seattle.json") })
        }
      }, "path---learn-and-live-in-seattle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---learn-and-live-in-seattle!./.cache/json/learn-and-live-in-seattle.json
// module id = 1226
// module chunks = 231608221292675